import BeAwareTabs from "./BeAwareTabs"


const BeAware = () => {
  return (
    <BeAwareTabs/>
  )
}

export default BeAware